import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import InputImages from '../../components/InputImages/InputImages';
import InputInfoProduct from '../../components/InputInfoProduct/InputInfoProduct';
import InputPrices from '../../components/InputPrices/InputPrices';
import Header from '../../components/Header/Header';
import NavInf from '../../components/NavInf/NavInf';
import Footer from '../../components/Footer/Footer';
import Alert from '../../components/Alert/Alert';
import Loader from '../../components/Loader/Loader';
import './EditProduct.css';
import { secureFetch } from '../../utils/secureFetch';
import AccordionSection from '../../components/AccordionSection/AccordionSection';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { isEmbedded } from '../../utils/isEmbedded';
import EmbeddedLayout from '../../components/EmbeddedLayout/EmbeddedLayout';

const EditProduct = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [initialImages, setInitialImages] = useState([]);
  const [initialPreviews, setInitialPreviews] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [imagesToDelete, setImagesToDelete] = useState([]);
  const [minPerVariant, setMinPerVariant] = useState('1');
  const [minTotalProduct, setMinTotalProduct] = useState('1');
  const [editQuantities, setEditQuantities] = useState(false);
  const [initialMinPerVariant, setInitialMinPerVariant] = useState(1);
  const [initialMinTotalProduct, setInitialMinTotalProduct] = useState(1);
  const [provider, setProvider] = useState(null);
  const [providerLoaded, setProviderLoaded] = useState(false);
  const [productLoaded, setProductLoaded] = useState(false);

  const [priceBlocks, setPriceBlocks] = useState([]);
  const [initialPriceBlocks, setInitialPriceBlocks] = useState([]);

  const [editImages, setEditImages] = useState(false);
  const [editInfo, setEditInfo] = useState(false);
  const [editPrices, setEditPrices] = useState(false);

  const [productName, setProductName] = useState('');
  const [description, setDescription] = useState('');
  const [productReference, setProductReference] = useState('');
  const [categoria, setCategoria] = useState(null);
  const [subcategoria, setSubcategoria] = useState(null);
  const [variantList, setVariantList] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [productStatus, setProductStatus] = useState('active');

  const [alertType, setAlertType] = useState(null);
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [isPublic, setIsPublic] = useState(false);

  useEffect(() => {
    const fetchProvider = async () => {
      try {
        const userId = JSON.parse(localStorage.getItem('usuario'))?.id;
        if (!userId) {
          setProvider(null);
          setProviderLoaded(true);
          return;
        }

        const res = await secureFetch('https://api.minymol.com/providers/me');
        if (!res.ok) throw new Error('Error en la respuesta del servidor');
        const data = await res.json();
        setProvider(data);
        setProviderLoaded(true);
      } catch (err) {
        setProvider(null);
        setProviderLoaded(true);
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchProvider();
      } else {
        setProvider(null);
        setProviderLoaded(true);
      }
    });

    return () => unsubscribe();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const [prodRes, imgRes, priceRes, catRes] = await Promise.all([
          fetch(`https://api.minymol.com/products/${uuid}`),
          fetch(`https://api.minymol.com/images/by-product/${uuid}`),
          fetch(`https://api.minymol.com/product-prices/product/${uuid}`),
          fetch(`https://api.minymol.com/categories/with/sub-categories`)
        ]);

        const prodData = await prodRes.json();
        const imgData = await imgRes.json();
        const priceData = await priceRes.json();
        const catData = await catRes.json();

        setCategorias(catData);

        setProductStatus(prodData.status);
        setIsPublic(prodData.isPublic ?? false);
        setProductName(prodData.name);
        setDescription(prodData.description);
        setProductReference(prodData.reference);
        setMinPerVariant(prodData.minPerVariant ?? 1);
        setMinTotalProduct(prodData.minTotalProduct ?? 1);
        setInitialMinPerVariant(prodData.minPerVariant ?? 1);
        setInitialMinTotalProduct(prodData.minTotalProduct ?? 1);

        const categoriaId = prodData.categoryId || prodData.category?.id;
        const categoriaSeleccionada = catData.find(c => c.id === categoriaId);
        setCategoria(categoriaSeleccionada ? { value: categoriaSeleccionada.id, label: categoriaSeleccionada.name } : null);

        const subcategoriaId = prodData.subCategoryId || prodData.subCategory?.id;
        const subCats = categoriaSeleccionada?.subCategories || [];
        const subcategoriaSeleccionada = subCats.find(sc => sc.id === subcategoriaId);
        setSubcategoria(subcategoriaSeleccionada ? { value: subcategoriaSeleccionada.id, label: subcategoriaSeleccionada.name } : null);

        setVariantList([
          prodData.sizes?.length ? { type: 'Talla', values: prodData.sizes.map(s => s.name), input: '' } : null,
          prodData.colors?.length ? { type: 'Color', values: prodData.colors.map(c => c.name), input: '' } : null,
        ].filter(Boolean));

        setImages(imgData);
        setPreviews(imgData.map(i => i.imageUrl));
        setInitialImages(imgData);
        setInitialPreviews(imgData.map(i => i.imageUrl));

        const formattedPrices = priceData.map((p) => ({
          id: p.id,
          cantidades: p.quantity?.split(',') || [],
          inputCantidad: '',
          precio: p.price,
          unidad: p.unity || 'unidad'
        }));
        setPriceBlocks(formattedPrices);
        setInitialPriceBlocks(formattedPrices);
        setProductLoaded(true);
      } catch (error) {
        setProductLoaded(true);
      }
    };

    fetchData();
  }, [uuid]);

  const subcategorias = categoria
    ? categorias.find(c => c.id === categoria.value)?.subCategories.map(sub => ({
      value: sub.id,
      label: sub.name
    }))
    : [];

  const cancelImageChanges = () => {
    setImages(initialImages);
    setPreviews(initialPreviews);
    setNewImages([]);
    setImagesToDelete([]);
    setEditImages(false);
  };

  const saveImageChanges = async () => {
    const productId = uuid;

    for (const file of newImages) {
      try {
        const mimeType = file.type;
        const filename = file.name;
        const signedRes = await secureFetch('https://api.minymol.com/images/signed-url', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ mimeType, filename, productId }),
        });

        const { signedUrl, finalUrl } = await signedRes.json();

        const uploadRes = await fetch(signedUrl, {
          method: 'PUT',
          body: file,
        });
        if (!uploadRes.ok) {
          throw new Error('Falló la subida al signed URL');
        }

        const registerRes = await secureFetch('https://api.minymol.com/images/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ productId, imageUrl: finalUrl, temporal: false })
        });
        if (!registerRes.ok) {
          throw new Error('Falló el registro de la imagen en el backend');
        }

      } catch (err) {
        // Error al subir imagen
      }
    }

    for (const image of imagesToDelete) {
      await secureFetch(`https://api.minymol.com/images/${image.id}`, { method: 'DELETE' });
    }

    setInitialImages(images);
    setInitialPreviews(previews);
    setNewImages([]);
    setImagesToDelete([]);
    setEditImages(false);
    setAlertType('success');
    setAlertMessage('Imágenes actualizadas exitosamente.');
    setShowAlert(true);
  };

  const cancelInfoChanges = () => {
    setEditInfo(false);
  };

  const saveInfoChanges = async () => {
    if (!productName.trim() || !description.trim() || !categoria) {
      setAlertType('error');
      setAlertMessage('Completa todos los campos requeridos.');
      setShowAlert(true);
      return;
    }

    const colors = [], sizes = [];
    for (const variant of variantList) {
      const type = variant.type?.toLowerCase();
      if (type === 'color') variant.values.forEach(c => colors.push({ name: c }));
      else if (type === 'talla') variant.values.forEach(t => sizes.push({ name: t }));
    }

    await secureFetch(`https://api.minymol.com/products/${uuid}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: productName,
        description,
        reference: productReference,
        categoryId: categoria.value,
        subCategoryId: subcategoria?.value || null,
        colors,
        sizes
      })
    });

    setEditInfo(false);
    setAlertType('success');
    setAlertMessage('Información actualizada exitosamente.');
    setShowAlert(true);
  };

  const cancelPriceChanges = () => {
    setPriceBlocks(initialPriceBlocks.map(p => ({ ...p, inputCantidad: '' })));
    setEditPrices(false);
  };

  const savePriceChanges = async () => {
    for (const block of priceBlocks) {
      const precio = parseFloat((block.precio || '').toString().replace(/\./g, ''));
      if (!block.cantidades.length || isNaN(precio) || precio <= 0) {
        setAlertType('error');
        setAlertMessage('Cada bloque de precio debe tener cantidades válidas y precio mayor a 0.');
        setShowAlert(true);
        return;
      }
    }

    const created = priceBlocks.filter(p => !initialPriceBlocks.find(b => b.id === p.id));
    const updated = priceBlocks.filter(p => initialPriceBlocks.find(b => b.id === p.id && (b.precio !== p.precio || b.cantidades.join(',') !== p.cantidades.join(','))));
    const deleted = initialPriceBlocks.filter(b => !priceBlocks.find(p => p.id === b.id));

    for (const block of created) {
      await secureFetch('https://api.minymol.com/product-prices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId: uuid,
          quantity: block.cantidades.join(','),
          unity: block.unidad,
          price: parseFloat(block.precio),
          description: `Aplica ${block.cantidades.join(',')} unidades`
        })
      });
    }

    for (const block of updated) {
      await secureFetch(`https://api.minymol.com/product-prices/${block.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          quantity: block.cantidades.join(','),
          unity: 'unidad',
          price: parseFloat(block.precio),
          description: `Aplica ${block.cantidades.join(',')} unidades`
        })
      });
    }

    for (const block of deleted) {
      await secureFetch(`https://api.minymol.com/product-prices/${block.id}`, {
        method: 'DELETE'
      });
    }

    setInitialPriceBlocks(priceBlocks);
    setEditPrices(false);
    setAlertType('success');
    setAlertMessage('Precios actualizados exitosamente.');
    setShowAlert(true);
  };

  const handleDeleteProduct = async () => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este producto? Esta acción no se puede deshacer.');
    if (!confirmDelete) return;

    try {
      const res = await secureFetch(`https://api.minymol.com/products/${uuid}`, { method: 'DELETE' });
      if (res.ok) {
        setAlertType('success');
        setAlertMessage('Producto eliminado exitosamente.');
        setShowAlert(true);
        setTimeout(() => navigate('/my-products'), 2000);
      } else throw new Error();
    } catch {
      setAlertType('error');
      setAlertMessage('Error al eliminar el producto.');
      setShowAlert(true);
    }
  };

  // Si aún no se han cargado los datos, mostrar solo el loader
  if (!providerLoaded || !productLoaded) {
    return (
      <>
        {showAlert && (
          <Alert type={alertType} message={alertMessage} onClose={() => setShowAlert(false)} />
        )}
        {!isEmbedded() && (
          <Header
            minimal={true}
            providerName={JSON.parse(localStorage.getItem('usuario'))?.proveedorInfo?.nombre_empresa}
            menuProvider={true}
            currentPage='products'
          />
        )}
        <Loader />
      </>
    );
  }

  return (
    <>
      {showAlert && (
        <Alert type={alertType} message={alertMessage} onClose={() => setShowAlert(false)} />
      )}
      {!isEmbedded() && (
        <Header
          minimal={true}
          providerName={JSON.parse(localStorage.getItem('usuario'))?.proveedorInfo?.nombre_empresa}
          menuProvider={true}
          currentPage='products'
        />
      )}
      {isEmbedded() && <EmbeddedLayout />}
      <div className="edit-product-container">

        <AccordionSection title="Estado">
          <div className='status-product' defaultValue='active'>
            <p className='status-text'>Estado:</p>
            <select
              className='status-select'
              value={productStatus}
              onChange={async (e) => {
                const newStatus = e.target.value;
                try {
                  const res = await secureFetch(`https://api.minymol.com/products/${uuid}/status`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ status: newStatus })
                  });
                  if (!res.ok) throw new Error();
                  setProductStatus(newStatus);
                  setAlertType('success');
                  setAlertMessage(`Estado actualizado a ${newStatus === 'active' ? 'activo' : 'inactivo'}.`);
                } catch {
                  setAlertType('error');
                  setAlertMessage('Error al actualizar el estado del producto.');
                }
                setShowAlert(true);
              }}
            >
              <option value='active'>Activo</option>
              <option value='inactive'>Inactivo</option>
            </select>

          </div>
        </AccordionSection>

        {provider?.canChangeVisibility && (
          <AccordionSection title="Visibilidad">
            <div className='visibility-product'>
              <p className='status-text'>Visibilidad:</p>
              <select
                className='status-select'
                value={isPublic ? 'public' : 'private'}
                onChange={async (e) => {
                  const newValue = e.target.value === 'public';
                  try {
                    const res = await secureFetch(`https://api.minymol.com/products/${uuid}/visibility`, {
                      method: 'PATCH',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ isPublic: newValue })
                    });
                    if (!res.ok) throw new Error();
                    setIsPublic(newValue);
                    setAlertType('success');
                    setAlertMessage(`Producto ahora es ${newValue ? 'visible al público' : 'privado'}.`);
                  } catch {
                    setAlertType('error');
                    setAlertMessage('Error al actualizar la visibilidad del producto.');
                  }
                  setShowAlert(true);
                }}
              >
                <option value='public'>Mostrar al público</option>
                <option value='private'>Privado</option>
              </select>
            </div>
          </AccordionSection>
        )}


        <AccordionSection title="Cantidades mínimas">
          <div className="min-quantities">
            <div className="input-group">
              <label>Cantidad mínima por variante:</label>
              <input
                type="number"
                value={minPerVariant}
                inputMode="numeric"
                onChange={(e) => setMinPerVariant(e.target.value)}
                disabled={!editQuantities}
              />
            </div>

            <div className="input-group">
              <label>Cantidad mínima total del producto:</label>
              <input
                type="number"
                inputMode="numeric"
                value={minTotalProduct}
                onChange={(e) => setMinTotalProduct(e.target.value)}
                disabled={!editQuantities}
              />
            </div>

            <div className="edit-controls">
              {editQuantities ? (
                <>
                  <button className='cancel-btn' onClick={() => {
                    setMinPerVariant(initialMinPerVariant);
                    setMinTotalProduct(initialMinTotalProduct);

                    setEditQuantities(false);
                  }}>Cancelar</button>
                  <button className='save-btn' onClick={async () => {
                    const min1 = parseInt(minPerVariant);
                    const min2 = parseInt(minTotalProduct);

                    if (isNaN(min1) || isNaN(min2) || min1 < 1 || min2 < 1) {
                      setAlertType('error');
                      setAlertMessage('Las cantidades deben ser números mayores a 0.');
                      setShowAlert(true);
                      return;
                    }

                    try {
                      const res = await secureFetch(`https://api.minymol.com/products/${uuid}`, {
                        method: 'PATCH',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ minPerVariant: min1, minTotalProduct: min2 })
                      });
                      if (!res.ok) throw new Error();

                      setInitialMinPerVariant(String(min1));
                      setInitialMinTotalProduct(String(min2));
                      setEditQuantities(false);
                      setAlertType('success');
                      setAlertMessage('Cantidades mínimas actualizadas.');
                    } catch {
                      setAlertType('error');
                      setAlertMessage('Error al actualizar las cantidades.');
                    }
                    setShowAlert(true);
                  }}>
                    Guardar cambios
                  </button>
                </>
              ) : (
                <button className='edit-btn' onClick={() => setEditQuantities(true)}>Editar</button>
              )}
            </div>
          </div>
        </AccordionSection>

        <AccordionSection title="Imágenes">
          <div className="edit-block">
            <InputImages
              images={images}
              previews={previews}
              setImages={setImages}
              setPreviews={setPreviews}
              editMode={true}
              editActive={editImages}
              setNewImages={setNewImages}
              setImagesToDelete={setImagesToDelete}
            />
            <div className="edit-controls">
              {editImages ? (
                <>
                  <button className='cancel-btn' onClick={cancelImageChanges}>Cancelar</button>
                  <button className='save-btn' onClick={saveImageChanges}>Guardar cambios</button>
                </>
              ) : (
                <button className='edit-btn' onClick={() => setEditImages(true)}>Editar</button>
              )}
            </div>
          </div>
        </AccordionSection>

        <AccordionSection title="Información del producto">
          <div className="edit-block">
            <InputInfoProduct
              productName={productName}
              setProductName={setProductName}
              description={description}
              setDescription={setDescription}
              productReference={productReference}
              setProductReference={setProductReference}
              categoria={categoria}
              setCategoria={setCategoria}
              subcategoria={subcategoria}
              setSubcategoria={setSubcategoria}
              categorias={categorias}
              subcategorias={subcategorias}
              variantList={variantList}
              setVariantList={setVariantList}
              editMode={true}
              editActive={editInfo}
            />
            <div className="edit-controls">
              {editInfo ? (
                <>
                  <button className='cancel-btn' onClick={cancelInfoChanges}>Cancelar</button>
                  <button className='save-btn' onClick={saveInfoChanges}>Guardar cambios</button>
                </>
              ) : (
                <button className='edit-btn' onClick={() => setEditInfo(true)}>Editar</button>
              )}
            </div>
          </div>
        </AccordionSection>

        <AccordionSection title="Precios del producto">
          <div className="edit-block">
            <InputPrices
              priceBlocks={priceBlocks}
              updatePriceBlock={(id, field, value) => {
                setPriceBlocks((prev) =>
                  prev.map((b) => (b.id === id ? { ...b, [field]: value } : b))
                );
              }}
              handleAddPriceBlock={() => {
                if (priceBlocks.length < 3) {
                  setPriceBlocks([...priceBlocks, { id: Date.now(), cantidades: [], inputCantidad: '', precio: '', unidad: 'unidad' }]);
                }
              }}
              handleRemovePriceBlock={(id) => {
                setPriceBlocks(priceBlocks.filter((b) => b.id !== id));
              }}
              editMode={true}
              editActive={editPrices}
            />
            <div className="edit-controls">
              {editPrices ? (
                <>
                  <button className='cancel-btn' onClick={cancelPriceChanges}>Cancelar</button>
                  <button className='save-btn' onClick={savePriceChanges}>Guardar cambios</button>
                </>
              ) : (
                <button className='edit-btn' onClick={() => setEditPrices(true)}>Editar</button>
              )}
            </div>
          </div>
        </AccordionSection>

        <div className="line"></div>

        <div className="edit-block">
          <div className="edit-controls">
            <button className='delete-btn' onClick={handleDeleteProduct}>Eliminar producto</button>
          </div>
        </div>
      </div>
      {!isEmbedded() && <NavInf />}
      {!isEmbedded() && <Footer />}
    </>
  );
};

export default EditProduct;
